module.exports = __webpack_public_path__ + "static/media/closed-book.02bee962.svg";